import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useHistory, Link } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import Slide from "react-reveal/Slide";
import VerificaToken from "../../components/VerificaToken";

function Accedi() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  let history = useHistory();

  const { user, setUser } = VerificaToken();

  const login = () => {
    const data = { email: email, password: password };
    axios
      .post("https://website-8bit-motors.herokuapp.com/account/login", data)
      .then((response) => {
        if (response.data.error) {
          alert(response.data.error);
        } else {
          localStorage.setItem("accessToken", response.data.token);
          axios
            .get(
              `https://website-8bit-motors.herokuapp.com/account/info/${response.data.id}`
            )
            .then((res) => {
              setUser(res.data);
            });
          history.push("loginEffettuato");
        }
      });
  };

  return (
    <Container fluid>
      {/* SEZIONE BANNER */}
      <Container
        fluid
        className="head-banner text-white text-center"
        id="banner_accesso"
      >
        <Row>
          <Col>
            <h1>
              <strong>8-Bit Motors</strong>
            </h1>
          </Col>
        </Row>
      </Container>

      <h2 className="text-center mt-3">
        Inserisci le tue credenziali di accesso per effettuare l'accesso!
      </h2>

      {/* SEZIONE FORM */}

      <Container>
        <br />
        <br />
        <br />

        <Formik>
          <Form style={{ textAlign: "center" }}>
            <Row className="mt-3">
              <Col>
                <Slide left>
                  <label className="mb-1 form_registrazione" for="email">
                    Email
                  </label>
                  <Field
                    type="email"
                    className="form-control input_registrazione"
                    name="email"
                    placeholder="Example@dominio.com"
                    onChange={(event) => {
                      setEmail(event.target.value);
                    }}
                  />
                </Slide>
              </Col>

              <Col>
                <Slide right>
                  <label className="mb-1 form_registrazione" for="password">
                    Password
                  </label>
                  <Field
                    type="password"
                    className="form-control input_registrazione"
                    name="email"
                    placeholder="Password"
                    onChange={(event) => {
                      setPassword(event.target.value);
                    }}
                  />
                </Slide>
              </Col>
            </Row>

            <Button
              onClick={login}
              variant="success"
              className="mt-4 collegamento"
            >
              Conferma
            </Button>
            <p className="mt-2">
              Hai dimenticato la password?
              <Link to="recuperaPassword"> Clicca Qui</Link>
            </p>
          </Form>
        </Formik>
      </Container>
      <br />
      <br />
      <br />
      <br />
    </Container>
  );
}

export default Accedi;
